var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.gloablLocale[_vm.locale]}},[_c('div',{staticClass:"n-main-ctx ovh"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }